import { KeycloakService, KeycloakOptions, KeycloakEventTypeLegacy } from 'keycloak-angular';
import { environment } from '../../environments/environment';

// Refresh the access token if it expires within this many seconds.
const TOKEN_REFRESH_MIN_VALIDITY_SEC = 30;

export function initializeKeycloak(keycloak: KeycloakService): () => Promise<boolean> {
  const keycloakOptions: KeycloakOptions = {
    config: {
      url: environment.keycloakConfig.url,
      realm: environment.keycloakConfig.realm,
      clientId: environment.keycloakConfig.clientId,
    },
    initOptions: {
      onLoad: 'check-sso',
      checkLoginIframe: true,
      silentCheckSsoRedirectUri: window.location.origin + '/assets/silent-check-sso.html',
      checkLoginIframeInterval: 5,
    },
  };

  return async () => {
    const authenticated = await keycloak.init(keycloakOptions);
    keycloak.keycloakEvents$.subscribe((event) => {
      if (event.type === KeycloakEventTypeLegacy.OnTokenExpired) {
        keycloak.updateToken(TOKEN_REFRESH_MIN_VALIDITY_SEC).catch(() => {
        });
      }
    });

    return authenticated;
  };
}

